
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.277 13.459v-1.566c1.154-.136 2.045-.96 2.045-1.957 0-.997-.89-1.821-2.045-1.957V5.354c.787.119 1.382.652 1.382 1.29a.332.332 0 10.663 0c0-.997-.891-1.822-2.045-1.957V3.121a.332.332 0 10-.663 0v1.566c-1.155.135-2.047.96-2.047 1.958 0 .996.892 1.82 2.047 1.955v2.627c-.787-.119-1.384-.652-1.384-1.291a.332.332 0 10-.663 0c0 .998.892 1.823 2.047 1.958v1.565a.332.332 0 10.663 0zM9.66 9.936c0 .638-.595 1.17-1.382 1.29v-2.58c.787.12 1.382.652 1.382 1.29zM6.23 6.644c0-.638.596-1.171 1.384-1.29v2.579c-.788-.12-1.384-.651-1.384-1.289z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.956 8.29c0-3.867-3.146-7.012-7.012-7.012-3.867 0-7.012 3.145-7.012 7.011a7.02 7.02 0 007.012 7.012 7.02 7.02 0 007.012-7.012zm-13.36 0C1.594 4.788 4.442 1.94 7.943 1.94c3.5 0 6.348 2.848 6.348 6.348s-2.848 6.349-6.348 6.349a6.355 6.355 0 01-6.349-6.349zM21.887 14.687l-.696-2.711a.332.332 0 00-.403-.24l-2.693.682a.331.331 0 10.163.644l1.925-.488-3.501 5.448-2.26-3.294a.345.345 0 00-.288-.144.332.332 0 00-.274.168l-3.039 5.38-3.21-2.35a.332.332 0 00-.442.046l-3.338 3.71a.332.332 0 10.494.445l3.136-3.488 3.27 2.392a.33.33 0 00.484-.104l2.96-5.24 2.242 3.267a.332.332 0 00.553-.008l3.779-5.88.495 1.93a.332.332 0 10.643-.165z","fill":"#fff"}})])
          )
        }
      }
    